module.exports = __webpack_public_path__ + "static/media/Right_Brick.7fc03175.png";